import store from '@/store'

export default [
    {
        path: '/',
        meta: { requiresGuest: true },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/pages/front/layout.vue'),
        children: [
            {
              path: '',
              name: 'home',
              meta: { requiresGuest: true },
              component: () => import('@/pages/front/index.vue')
            },
            {
              path: '/about-us',
              name: 'front-about-us',
              meta: { requiresGuest: true },
              component: () => import('@/pages/front/about-us/index.vue')
            },
            {
              path: '/privacies',
              name: 'front-privacy',
              meta: { requiresGuest: true },
              component: () => import('@/pages/front/privacy/index.vue')
            },
            {
              path: '/news',
              name: 'front-news',
              meta: { requiresGuest: true },
              component: () => import('@/pages/front/news/index.vue'),
            },
            {
              path: '/news/:id',
              name: 'front-news-show',
              meta: { requiresGuest: true },
              component: () => import('@/pages/front/news/show.vue')
            },
            {
              path: '/results',
              name: 'front-result',
              meta: { requiresGuest: true },
              component: () => import('@/pages/front/result/index.vue')
            }
        ]
      },
]
